module.exports = __webpack_public_path__ + "img/nh3-emissions.6400f397.svg";